import { render } from "./LoginResponse.vue?vue&type=template&id=04d78bb5"
import script from "./LoginResponse.vue?vue&type=script&lang=js"
export * from "./LoginResponse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__